import { render, staticRenderFns } from "./CustomConfirm.vue?vue&type=template&id=374f21f1&scoped=true&"
import script from "./CustomConfirm.vue?vue&type=script&lang=js&"
export * from "./CustomConfirm.vue?vue&type=script&lang=js&"
import style0 from "./CustomConfirm.vue?vue&type=style&index=0&id=374f21f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374f21f1",
  null
  
)

export default component.exports